import makePaymentAuthorizationPath from 'shared_js/helpers/urlHelper/makePaymentAuthorizationPath';
import buildBuka20Url from 'shared_js/helpers/urlHelper/buildBuka20Url';
import mitraPaymentDomainBaseUrl from 'shared_js/helpers/urlHelper/mitraPaymentDomainBaseUrl';

export default {
  methods: {
    redirectToPaymentAuthorizationPage({ invoiceGroupNumber, transactionId }) {
      const currentBaseUrl = window.location.origin;
      const redirectionUrl = new URL(
        `${currentBaseUrl}/item-mitra/transactions/${transactionId}`,
      );

      const paymentAuthUrl = new URL(
        `${mitraPaymentDomainBaseUrl}${makePaymentAuthorizationPath(
          invoiceGroupNumber,
        )}`,
      );

      paymentAuthUrl.searchParams.append('redirectionUrl', redirectionUrl.href);
      const url = buildBuka20Url(paymentAuthUrl.href);
      window.location.assign(url);
    },
  },
};
